// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uhl6","left":"styles_left__2-w6f","desktopActions":"styles_desktopActions__3SE6J","title":"styles_title__82pCU"};